/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  /**
   * Free shipping label on product pages
   * ------------------------------------
   * Swaps the "Sofort lieferbar" text in the availability bullets of
   * snippets/product.liquid for "Kostenloser Versand" as soon as the
   * threshold from settings.free_shipping_limit would be met by the current
   * cart PLUS the product on screen - so the visitor sees it before adding
   * the item, not only afterwards.
   *
   * Markup comes from snippets/shipping-label.liquid. Liquid already renders
   * the correct initial state; this script keeps it up to date, because the
   * cart changes via AJAX and the price changes on variant switches.
   *
   * Threshold and product price are read off the element - no value is
   * duplicated here, the theme setting stays the single source of truth.
   */
  (function () {
    var SELECTOR = "[data-shipping-label]";

    // Theme events (see assets/theme.js) instead of observing the DOM.
    var CART_EVENTS = [
      "theme:cart:added",
      "theme:cart:loaded",
      "theme:cart:update",
    ];

    // Cached so a variant switch can re-render without re-fetching the cart.
    var cartTotal = null;

    function paint(scope) {
      if (cartTotal === null) return;
      (scope || document).querySelectorAll(SELECTOR).forEach(function (el) {
        var limit = parseFloat(el.dataset.limit || "0");
        if (!(limit > 0)) return;
        var productPrice = parseFloat(el.dataset.productPriceCents || "0") / 100;
        el.textContent =
          cartTotal + productPrice >= limit
            ? el.dataset.reached
            : el.dataset.fallback;
      });
    }

    function refresh() {
      // Only on pages that have a label - skips the request everywhere else.
      if (!document.querySelector(SELECTOR)) return;

      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (res) {
          return res.ok ? res.json() : Promise.reject(res.status);
        })
        .then(function (cart) {
          cartTotal = cart.total_price / 100;
          paint();
        })
        .catch(function () {
          /* On failure the Liquid-rendered state stays as is. */
        });
    }

    CART_EVENTS.forEach(function (name) {
      document.addEventListener(name, refresh);
    });

    /*
     * Bundle apps (FastBundle on the GG Creme page, Fly Bundles, Opus upsell)
     * write to the cart through their own AJAX calls and never fire the theme
     * events above, which left the label stale there until a reload.
     * Watching the network layer catches every cart mutation regardless of
     * which app triggered it. /cart.js itself is a read and not matched, so
     * refresh() cannot trigger itself.
     */
    var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

    function isCartWrite(url) {
      return typeof url === "string" && CART_WRITE.test(url);
    }

    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var result = nativeFetch.apply(this, arguments);
        if (isCartWrite(url) && result && result.then) {
          result.then(refresh, function () {});
        }
        return result;
      };
    }

    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartWrite(url)) this.addEventListener("load", refresh);
      return nativeOpen.apply(this, arguments);
    };

    // A different variant can carry a different price, which moves the
    // threshold. Scope the update to the section the event came from, so a
    // quick-view popup cannot overwrite the label of the page behind it.
    document.addEventListener("theme:variant:change", function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      var scope = event.target.closest
        ? event.target.closest(".shopify-section") || document
        : document;

      scope.querySelectorAll(SELECTOR).forEach(function (el) {
        el.dataset.productPriceCents = variant.price;
      });
      paint(scope);
    });

    refresh();
  })();

  /**
   * Scarcity countdown on the redesigned product page
   * -------------------------------------------------
   * Fills the bar of snippets/gloria-scarcity-countdown.liquid when it
   * scrolls into view, and ticks its timer - when the block has one - down
   * to the daily reset time, starting over the next day.
   *
   * The reset time is read off the element, so the theme setting stays the
   * single source of truth. Liquid renders the first frame in the shop's
   * timezone; from the first tick on the countdown follows the visitor's clock,
   * which is what the reference page does too.
   */
  (function () {
    var SELECTOR = "[data-gl-countdown]";

    function pad(value) {
      return value < 10 ? "0" + value : String(value);
    }

    // Next occurrence of HH:MM in the visitor's timezone.
    function msUntilReset(resetTime) {
      var parts = String(resetTime || "23:59").split(":");
      var hours = parseInt(parts[0], 10);
      var minutes = parseInt(parts[1], 10);
      if (isNaN(hours) || isNaN(minutes)) return 0;

      var now = new Date();
      var target = new Date();
      target.setHours(hours, minutes, 0, 0);
      if (target <= now) target.setDate(target.getDate() + 1);

      return target - now;
    }

    function tick() {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        var display = el.querySelector("[data-gl-countdown-display]");
        if (!display) return;

        var remaining = Math.max(0, Math.floor(msUntilReset(el.dataset.glResetTime) / 1000));
        display.textContent =
          pad(Math.floor(remaining / 3600)) +
          ":" +
          pad(Math.floor((remaining % 3600) / 60)) +
          ":" +
          pad(remaining % 60);
      });
    }

    // Skips the interval on every page that has no timer - the block can be
    // set up without one.
    if (document.querySelector(SELECTOR + " [data-gl-countdown-display]")) {
      tick();
      setInterval(tick, 1000);
    }

    // Scroll-in: the bar fills and the number counts up to it, once, when
    // the block comes into view. The fill itself is a CSS transition on
    // `is-filled` (custom-ks.css); the count runs on the same curve and
    // duration, so number and bar arrive together. With reduced motion, or
    // without an observer, both show their final state straight away.
    var DURATION = 1600;
    var reduceMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // The curve of cubic-bezier(0.22, 1, 0.36, 1), close enough for a count.
    function easeOutQuint(t) {
      return 1 - Math.pow(1 - t, 5);
    }

    function countUp(el) {
      var target = parseInt(el.getAttribute("data-gl-countdown-value"), 10);
      if (isNaN(target)) return;

      var start = null;
      el.textContent = "0";

      function frame(now) {
        if (start === null) start = now;
        var t = Math.min(1, (now - start) / DURATION);
        el.textContent = String(Math.round(target * easeOutQuint(t)));
        if (t < 1) requestAnimationFrame(frame);
      }

      requestAnimationFrame(frame);
    }

    function fill(block) {
      block.classList.add("is-filled");
      if (reduceMotion) return;

      var value = block.querySelector("[data-gl-countdown-value]");
      if (value) countUp(value);
    }

    var observer =
      !reduceMotion && "IntersectionObserver" in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                observer.unobserve(entry.target);
                fill(entry.target);
              });
            },
            // Starts once a good part of the block is on screen, not at its
            // edge.
            { threshold: 0.6 }
          )
        : null;

    function watch(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (block) {
        if (observer) observer.observe(block);
        else fill(block);
      });
    }

    watch(document);

    // The theme editor re-renders the section on every settings change, with
    // a fresh, empty bar - without this it would stay empty in the preview.
    document.addEventListener("shopify:section:load", function (event) {
      watch(event.target);
    });
  })();

  /**
   * Arrows for the horizontal card strips
   * -------------------------------------
   * Shared by every strip that marks itself up as [data-gl-scroller] - the
   * testimonial row and the results row today. The strips themselves are CSS
   * scroll-snap, so this only moves them by one card and keeps the two buttons
   * honest: hidden while nothing overflows, disabled at either end.
   *
   * Nothing here knows what a card is. The step comes off the rendered strip,
   * so it follows the breakpoint without a single width being repeated in JS.
   */
  (function () {
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    // A scroll asked for in JS animates even where the stylesheet says not to,
    // so the preference has to be read here as well.
    function behavior() {
      return reducedMotion.matches ? "auto" : "smooth";
    }

    document.querySelectorAll("[data-gl-scroller]").forEach(function (scroller) {
      var strip = scroller.querySelector("[data-gl-scroller-strip]");
      var prev = scroller.querySelector("[data-gl-scroller-prev]");
      var next = scroller.querySelector("[data-gl-scroller-next]");
      var card = strip && strip.firstElementChild;
      if (!strip || !prev || !next || !card) return;

      function step() {
        var gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function update() {
        // 2px of slack: a fractional card width never lets scrollLeft reach
        // the theoretical maximum exactly.
        var max = strip.scrollWidth - strip.clientWidth;
        var scrollable = max > 2;

        prev.hidden = !scrollable;
        next.hidden = !scrollable;
        prev.disabled = strip.scrollLeft <= 2;
        next.disabled = strip.scrollLeft >= max - 2;
      }

      prev.addEventListener("click", function () {
        strip.scrollBy({ left: -step(), behavior: behavior() });
      });

      next.addEventListener("click", function () {
        strip.scrollBy({ left: step(), behavior: behavior() });
      });

      strip.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);

      // Once more when images and webfonts have landed: whether a strip
      // overflows is not decided until then.
      window.addEventListener("load", update);
      update();
    });
  })();

  /**
   * Sticky add-to-cart bar on the redesigned product page
   * -----------------------------------------------------
   * Three jobs, all fixing something the reference page gets wrong:
   *
   * 1. The bar appears once the real add-to-cart button has scrolled out of
   *    view, instead of at a fixed scroll offset. The reference switches at
   *    1300px on every breakpoint, which on mobile shows the bar while the
   *    real button is still below the fold - two add-to-carts at once.
   * 2. The price follows the selected variant and the selected bundle tier.
   *    The reference keeps showing the price the page was rendered with.
   * 3. The button adds to the cart. The reference's only scrolls back to
   *    the buy box.
   *
   * The theme's own bar, on every template without the redesign, keeps its
   * scroll handler in sections/product.liquid and is untouched.
   */
  (function () {
    var bar = document.querySelector("#sticky_atc.gl-pdp");
    if (!bar) return;

    // The buy area, not the theme's own add-to-cart button: a bundle app can
    // replace that button with its own and leave the original display:none,
    // which an observer would never see leave the viewport.
    function firstVisible(selectors) {
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.offsetParent && el.getBoundingClientRect().height > 0) return el;
      }
      return null;
    }

    var trigger = firstVisible([
      ".product-single__details .shopbtnwrp",
      ".product-single__details [data-form-wrapper]",
    ]);

    function show(visible) {
      bar.classList.toggle("sticky-visible", visible);
      bar.classList.toggle("sticky-hidden", !visible);
    }

    if (trigger && "IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          // Only once the button has left upwards - not before the page is
          // scrolled past it, and not while the footer is in view.
          var entry = entries[0];
          show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      ).observe(trigger);
    } else {
      // No observer: fall back to the theme's fixed offset.
      window.addEventListener("scroll", function () {
        show((window.pageYOffset || document.documentElement.scrollTop) > 1000);
      });
    }

    // Mirror the price the buy box shows into the bar, so the money format
    // stays the shop's own and no formatting is duplicated here.
    //
    // Two things rewrite that price: the theme on a variant change, and Fly
    // Bundles when a bundle tier is picked - the app writes its tier price and
    // compare price straight into the same [data-product-price] and
    // [data-compare-price] elements and fires no event. So the wrapper is
    // watched for any change instead, which covers both. The bar is written
    // only when its content actually differs, so the observer never feeds on
    // its own work.
    var priceWrapper = document.querySelector(
      ".product-single__details [data-price-wrapper]"
    );

    function syncPrice() {
      var price = document.querySelector(
        ".product-single__details [data-product-price]"
      );
      var compare = document.querySelector(
        ".product-single__details [data-compare-price]"
      );

      if (price) {
        bar.querySelectorAll("[data-gl-sticky-price]").forEach(function (el) {
          if (el.innerHTML !== price.innerHTML) el.innerHTML = price.innerHTML;
        });
      }

      var barCompare = bar.querySelector("[data-gl-sticky-compare-price]");
      var compareHtml = compare ? compare.innerHTML : "";
      if (barCompare && barCompare.innerHTML !== compareHtml) {
        barCompare.innerHTML = compareHtml;
      }
    }

    document.addEventListener("theme:variant:change", syncPrice);

    if (priceWrapper && "MutationObserver" in window) {
      new MutationObserver(syncPrice).observe(priceWrapper, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    // The app may already have applied its preselected tier before this ran.
    syncPrice();

    // The bar's button clicks the buy box's real one. That button belongs to
    // Fly Bundles, so the bundle tier picked there goes into the cart as
    // selected - a second form in the bar would add the plain variant
    // instead. The theme's own button is the fallback for a product without
    // a bundle. With neither clickable (sold out, app not loaded, class names
    // changed in an app update), the link does what it did before and scrolls
    // back to the buy box.
    var cta = bar.querySelector(".gl-sticky-cta");
    if (cta) {
      cta.addEventListener("click", function (event) {
        var button = firstVisible([
          ".product-single__details .gfbVolumeDiscountWidgetOfferAddToCartButton",
          ".product-single__details [data-add-to-cart]",
        ]);
        if (!button || button.disabled) return;

        event.preventDefault();
        button.click();
      });
    }
  })();

  /**
   * Installment line in the redesigned buy box
   * ------------------------------------------
   * "oder 6 monatliche Raten von ..." is rendered by a custom_code block in
   * the sandbox template, from the price the page was loaded with. The buy
   * box price changes afterwards - on a variant change, and when a Fly
   * Bundles tier is picked, which the app writes straight into
   * [data-product-price] without an event. The rate follows it here, with the
   * same arithmetic as the Liquid: the price divided by the number of rates,
   * rounded up to the cent. The line hides below the threshold, as the Liquid
   * leaves it out there.
   */
  (function () {
    var line = document.querySelector(".gl-pdp [data-gl-installments]");
    if (!line) return;

    var amount = line.querySelector("[data-gl-installment-amount]");
    var wrapper = document.querySelector(
      ".product-single__details [data-price-wrapper]"
    );
    var formatMoney =
      window.themeVendor &&
      themeVendor.themeCurrency &&
      themeVendor.themeCurrency.formatMoney;
    if (!amount || !wrapper || !formatMoney || !window.theme) return;

    var count = parseInt(line.getAttribute("data-gl-installments"), 10);
    var min = parseInt(line.getAttribute("data-gl-installments-min"), 10) || 0;

    // The displayed price in cents. German format, "1.234,56 €" -> 123456 -
    // the same reading as the discount badge in snippets/product.liquid.
    function priceInCents() {
      var el = wrapper.querySelector("[data-product-price]");
      var text = el ? (el.textContent || "").replace(/[^\d.,]/g, "") : "";
      if (!text) return null;
      var value = parseFloat(text.replace(/\./g, "").replace(",", "."));
      return isNaN(value) ? null : Math.round(value * 100);
    }

    function update() {
      var price = priceInCents();
      if (price === null || !count) return;

      line.hidden = price <= min;

      // Written only when it differs, like the sticky bar's price.
      var html = formatMoney(Math.ceil(price / count), theme.moneyFormat);
      if (amount.innerHTML !== html) amount.innerHTML = html;
    }

    document.addEventListener("theme:variant:change", update);

    if ("MutationObserver" in window) {
      new MutationObserver(update).observe(wrapper, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    // The app may already have applied its preselected tier before this ran.
    update();
  })();

  /**
   * Testimonial slider
   * ------------------
   * Two jobs for sections/gloria-testimonials.liquid, which is a CSS
   * scroll-snap strip rather than a slider library:
   *
   * 1. "Mehr lesen" per card. The quote is clamped to five lines in CSS; the
   *    toggle only appears on the cards where that clamp actually cuts
   *    something off, which is measurable in the browser and nowhere else.
   * 2. The two arrows. They scroll by one card and switch themselves off at
   *    either end. On a strip that does not overflow - few testimonials, wide
   *    screen - they stay hidden entirely.
   *
   * Both labels come out of the section settings via data attributes, so no
   * customer-facing copy lives in this file.
   */
  (function () {
    var sections = document.querySelectorAll("[data-gl-testimonials]");
    if (!sections.length) return;

    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    /**
     * Opens or closes one quote, animating the height it settles at.
     *
     * A content height cannot be transitioned, so both ends are measured and
     * the box is driven between them in pixels. The quote stays unclamped for
     * the whole movement, in either direction: on the way back the clamp would
     * otherwise cut it to five lines in a single frame and leave the box
     * animating over empty space. What it is left with afterwards is decided
     * on transitionend, and the inline height is handed back to the stylesheet
     * there as well.
     */
    function toggleQuote(text, button, labels) {
      // The button's own state, not the class: during a collapse the class is
      // still on the element, and a click in that moment means "open again".
      var expanding = button.getAttribute("aria-expanded") !== "true";

      button.setAttribute("aria-expanded", expanding ? "true" : "false");
      button.textContent = expanding ? labels.less : labels.more;

      if (reducedMotion.matches) {
        text.classList.toggle("is-expanded", expanding);
        return;
      }

      var start = text.getBoundingClientRect().height;

      // Measure the target state before showing it: the class decides whether
      // the clamp applies, and height:auto makes the box report where it would
      // come to rest.
      text.classList.toggle("is-expanded", expanding);
      text.style.height = "auto";
      var end = text.getBoundingClientRect().height;

      text.classList.add("is-expanded");
      text.dataset.glCollapsing = expanding ? "" : "1";
      text.style.height = start + "px";

      // Read the layout back, or both assignments land in one recalculation
      // and there is nothing to transition between.
      void text.offsetHeight;
      text.style.height = end + "px";
    }

    function settleQuote(event) {
      if (event.propertyName !== "height") return;

      var text = event.currentTarget;
      text.style.height = "";
      if (text.dataset.glCollapsing) text.classList.remove("is-expanded");
      delete text.dataset.glCollapsing;
    }

    function setUpReadMore(section) {
      var labels = {
        more: section.dataset.glMoreLabel || "",
        less: section.dataset.glLessLabel || section.dataset.glMoreLabel || "",
      };

      section.querySelectorAll("[data-gl-tm-more]").forEach(function (button) {
        var text = button.parentElement.querySelector("[data-gl-tm-text]");
        var paragraph = text && text.querySelector("p");
        if (!paragraph) return;

        button.hidden = false;

        // A clamped paragraph reports more scroll height than it shows. One
        // pixel of tolerance, because sub-pixel line heights round either way.
        // A quote that fits keeps the button's line but not the button, so the
        // cards stay the same height - see .gl-tm__more--empty.
        if (paragraph.scrollHeight - paragraph.clientHeight < 2) {
          button.classList.add("gl-tm__more--empty");
          return;
        }

        text.addEventListener("transitionend", settleQuote);
        button.addEventListener("click", function () {
          toggleQuote(text, button, labels);
        });
      });
    }

    function setUp() {
      sections.forEach(setUpReadMore);
    }

    // The clamp is measured in rendered lines, so the webfont has to be in
    // before the measurement - a deferred script runs well before that.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setUp);
    } else {
      setUp();
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
